import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTelegram,
  faLinkedin,
  faTwitter,
  faSpotify,
  faGithub,
} from "@fortawesome/free-brands-svg-icons";
import "./LinkTree.css";

const LinkTree = () => {
  const links = [
    {
      title: "˖✦˖ Desktop OS ˖✦˖",
      url: "https://danials.org/desktop",
      icon: "⌘", // Mac-style command key symbol
    },
    {
      title: "Medium Articles",
      url: "https://danialm.medium.com/",
      icon: "✎", // writing pen symbol
    },
    {
      title: "Favorite Podcasts",
      url: "/podcast",
      icon: "☊", // headphone/audio symbol
    },
    {
      title: "Favorite Movies",
      url: "/movies",
      icon: "✷", // star symbol (retro cinema vibe)
    },
    {
      title: "Spotify Playlist",
      url: "https://open.spotify.com/playlist/2H0tag3jDXMYcQO9kSPiNR?utm_medium=share",
      icon: "♬", // music notes symbol
    },
    // {
    //   title: "Monero Wallet",
    //   url: "#",
    //   icon: "₿", // Bitcoin/crypto symbol
    //   isWallet: true,
    //   address:
    //     "8B5RVmzPgFshB9fXRbUgQ56CGXzgrw4aq5KoTPkZEJFiLQ7skxj5PSnN2okJM1vzX7jp64wpuAHPBETF3DPPV8xWGDmR6RR",
    // },
    // {
    //   title: "Liked Spotify Songs",
    //   url: "/spotify",
    //   icon: "♪", // single music note, minimal
    // },
    // {
    //   title: "Traveled Places",
    //   url: "/travel",
    //   icon: "⌖", // location/target symbol
    // },
    // {
    //   title: "Favorite Retro Games",
    //   url: "https://games.danials.space/",
    //   icon: "◉", // arcade button style
    // },
  ];

  const socials = [
    {
      platform: "Telegram",
      url: "https://t.me/DanialMDev",
      icon: faTelegram,
    },
    {
      platform: "LinkedIn",
      url: "https://www.linkedin.com/in/danial-mohammadzadeh",
      icon: faLinkedin,
    },
    {
      platform: "Twitter",
      url: "https://x.com/utsubyononeko",
      icon: faTwitter,
    },
    {
      platform: "Spotify",
      url: "https://open.spotify.com/user/e8msd2y920vucomwz58l9nip7",
      icon: faSpotify,
    },
    {
      platform: "GitHub",
      url: "https://github.com/danial2026",
      icon: faGithub,
    },
  ];

  return (
    <div className="linktree-container">
      <div className="content-wrapper desktop-row">
        <header className="profile-section">
          <div className="linktreeProfileImage">
            <img src="./wewe.jpg" alt="Profile" />
          </div>
          <h1>Danial M.</h1>
          <p className="bio">
            I'm a developer and startup founder and would love to grab a coffee
            with you ☕︎
          </p>
        </header>

        <div className="content-right">
          <main className="links-section">
            {links.map((link, index) => (
              <a
                key={index}
                href={link.url}
                className="link-button"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: link.isWallet ? "pointer" : "default",
                }}
                onClick={(e) => {
                  if (link.isWallet) {
                    e.preventDefault();
                    // Copy address to clipboard
                    navigator.clipboard.writeText(link.address);
                    alert("Monero wallet address copied to clipboard!");
                  }
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}></div>
                <span
                  className="link-icon"
                  style={{
                    padding: "4px",
                    marginRight: "10px",
                    fontSize: "28px",
                  }}
                >
                  {link.icon}
                </span>
                <span style={{ flexGrow: 1 }}>{link.title}</span>
              </a>
            ))}
          </main>

          <footer className="social-section">
            <div className="social-icons">
              {socials.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  className="social-icon"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.platform}
                  style={{ color: social.color }}
                >
                  <FontAwesomeIcon icon={social.icon} />
                </a>
              ))}
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default LinkTree;
